// Shared top navbar for public marketing pages (Landing, Pricing). Auth-aware:
// anonymous visitors get Log in / Sign up; signed-in users get links back into
// the app. Keeps these pages feeling like part of the same site.

import { useAuth, useNavigate } from "../contexts/AppContext";

export function SiteNav() {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const authed = auth.status === "authed";
  const currentPath = window.location.pathname;

  const go = (path: string) => (e: Event) => {
    e.preventDefault();
    navigate(path);
  };

  const navLinkClass = (path: string) =>
    "text-muted text-decoration-none small" +
    (currentPath === path ? " active" : "");

  return (
    <nav class="navbar navbar-expand py-3 border-bottom">
      <div class="container">
        <a class="navbar-brand fw-bold" href="/" onClick={go("/")}>
          MyPortal
        </a>
        <div class="ms-auto d-flex align-items-center gap-2 gap-sm-3">
          <a class={`${navLinkClass("/")} d-none d-sm-inline`} href="/" onClick={go("/")}>
            Home
          </a>
          <a
            class={navLinkClass("/pricing")}
            href="/pricing"
            onClick={go("/pricing")}
          >
            Pricing
          </a>
          {authed ? (
            <>
              <a
                class={`${navLinkClass("/account")} d-none d-sm-inline`}
                href="/account"
                onClick={go("/account")}
              >
                Account
              </a>
              <a class="btn btn-primary btn-sm" href="/" onClick={go("/")}>
                Pages
              </a>
            </>
          ) : (
            <>
              <a
                class={`${navLinkClass("/login")} d-none d-sm-inline`}
                href="/login"
                onClick={go("/login")}
              >
                Log in
              </a>
              <a
                class="btn btn-primary btn-sm"
                href="/signup"
                onClick={go("/signup")}
              >
                Sign up
              </a>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
